import React from 'react';

export interface ILoadingProps {
    color?: string;
    size?: number;
    inline?: boolean;
}

const Loading: React.FC<ILoadingProps> = ({ color = 'primary', size = 3, inline }) => {
    // Honouring the legacy "inline" prop that used to exist on this component.
    const _size = inline ? Math.min(2,size) : size;
    return (
        <div className={ inline ? 'd-inline-block p-1' : 'd-flex justify-content-center p-1'}>
            <div
                className={`spinner-border text-${color} ${inline?'spinner-border-sm':''}`}
                role="status"
                style={{ width: `${_size}rem`, height: `${_size}rem` }}
            >
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    );
};

export default Loading;
